var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24213_17362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.50081C8.62734 1.35032 8.78485 1.22784 8.96251 1.14115C9.14016 1.05446 9.33405 1.00547 9.53182 0.997314C9.72959 0.989153 9.92691 1.022 10.1112 1.09375C10.2955 1.1655 10.4627 1.27459 10.6022 1.41407C10.7416 1.55354 10.8503 1.72034 10.9213 1.90383C10.9922 2.08732 11.0239 2.28347 11.0143 2.4798C11.0047 2.67612 10.954 2.8683 10.8654 3.04409C10.7769 3.21988 10.6524 3.37542 10.5 3.50081L3.75 10.2508L1 11.0008L1.75 8.25081L8.5 1.50081Z",
    stroke: "black",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.5L9.5 4.5",
    stroke: "black",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24213_17362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagEdit);
export default __webpack_public_path__ + "static/media/BagEdit.28d4af6c29ba58e8e90e40df4b40e07a.svg";
export { ForwardRef as ReactComponent };